import { DeleteOutline } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AddMoreButton from './AddMoreButton';
import FormTextWithFileDrop from './FormTextWithFileDrop';

FormTextWithFileDropAndAddMore.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  textFieldName: PropTypes.string,
  requireNameWhenHasFiles: PropTypes.bool,
};

export default function FormTextWithFileDropAndAddMore({
  fieldName,
  fieldAttributes,
  focusedField,
  setFocusedField,
  textFieldName = 'name',
  requireNameWhenHasFiles = false,
}) {
  const { control, getValues } = useFormContext();
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  const { fields, append, update } = useFieldArray({
    control,
    name: fieldName,
    keyName: '_id',
  });

  const visibleRows = fields.map((field, index) => ({ ...field, index })).filter((row) => !row.deleteFlag);

  const isEditable = fieldAttributes?.isEditable && !isCanceled;

  return (
    <>
      {visibleRows.map((row) => (
        <Grid container key={row._id} spacing={1} alignItems="center" sx={{ mb: 1 }}>
          <Grid item xs={visibleRows.length > 1 ? 11.5 : 12}>
            <FormTextWithFileDrop
              fieldName={`${fieldName}[${row.index}]`}
              fieldAttributes={fieldAttributes}
              textFieldName={textFieldName}
              requireNameWhenHasFiles={requireNameWhenHasFiles}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
            />
          </Grid>
          {visibleRows.length > 1 && (
            <Grid item xs={0.5} sx={{ display: 'flex', justifyContent: 'center' }}>
              <IconButton
                onClick={() => {
                  const rowValue = getValues(`${fieldName}[${row.index}]`) || {};
                  update(row.index, { ...rowValue, deleteFlag: true });
                }}
                disabled={!isEditable}
                color="error"
              >
                <DeleteOutline />
              </IconButton>
            </Grid>
          )}
        </Grid>
      ))}

      <AddMoreButton
        buttonLabel="Add more"
        handleAddMoreClick={() => append({ id: 0, [textFieldName]: '', files: [], deleteFlag: false })}
        disabled={!isEditable}
      />
    </>
  );
}
